import { BaseModel, BaseModelArray } from '@eview/core/base/base-model';

/** Workflow status set for a report format (`forms.status_scheme`). */
export enum FormStatusScheme {
  Default = 'default',
  OnpeMace = 'onpe_mace'
}

export interface Form extends BaseModel {
  name_am?: any;
  id: number;
  name?: string;
  description?: string;
  type?: string;
  disabled?: boolean;
  /** When several formats of the same type are enabled, this one is pre-selected in the UI. */
  is_default?: boolean;
  /** default = legacy statuses; onpe_mace = Estados ONPE/MACE */
  status_scheme?: FormStatusScheme | string;
}

/** Truthy `is_default` from API (bool, 0/1, "1"); disabled forms never rank as default. */
function formDefaultRank(form: Form): number {
  if (form.disabled) {
    return 0;
  }
  const v: unknown = (form as Form & { is_default?: unknown }).is_default;
  if (v === true) {
    return 1;
  }
  if (typeof v === 'number' && v === 1) {
    return 1;
  }
  if (typeof v === 'string' && (v === '1' || v.toLowerCase() === 'true')) {
    return 1;
  }
  return 0;
}

/** Default format first, then name (locale), then id — used by map rail, filters, dropdowns. */
export function sortFormsDefaultFirst<T extends Form>(forms: T[]): T[] {
  return [...forms].sort((a, b) => {
    const byDefault = formDefaultRank(b) - formDefaultRank(a);
    if (byDefault !== 0) {
      return byDefault;
    }
    const na = a.name != null ? String(a.name) : '';
    const nb = b.name != null ? String(b.name) : '';
    const byName = na.localeCompare(nb, undefined, { sensitivity: 'base' });
    if (byName !== 0) {
      return byName;
    }
    return Number(a.id) - Number(b.id);
  });
}

export interface Forms extends BaseModelArray<Form> {}
